import { observable } from "mobx";
import VehicleChangeApplicationRejectionReason from "./vehicleChangeApplicationRejectionReason";
import VehicleChangeApplicationWarningReason from "./vehicleChangeApplicationWarningReason";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class VehicleChangeApplicationProductionResponse {
  /**
   * If true - application is valid and can be submitted.
   */
  @observable
  canBeAppliedFor!: boolean;

  @observable
  rejectionReason?: VehicleChangeApplicationRejectionReason;

  /**
   * Warning reasons.
   */
  @observable
  warningReasons?: VehicleChangeApplicationWarningReason[];

  /**
   * Charge management URL - only filled when charge before validity exists.
   */
  @observable
  chargeManagementUrl?: string;
}
